import { render, staticRenderFns } from "./AssignUserRoles.vue?vue&type=template&id=7f4fad5d&scoped=true&"
import script from "./AssignUserRoles.vue?vue&type=script&lang=js&"
export * from "./AssignUserRoles.vue?vue&type=script&lang=js&"
import style0 from "./AssignUserRoles.vue?vue&type=style&index=0&id=7f4fad5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4fad5d",
  null
  
)

export default component.exports